import { render, staticRenderFns } from "./addValueProductDialog.vue?vue&type=template&id=4e19fa6e&scoped=true"
import script from "./addValueProductDialog.vue?vue&type=script&lang=js"
export * from "./addValueProductDialog.vue?vue&type=script&lang=js"
import style0 from "./addValueProductDialog.vue?vue&type=style&index=0&id=4e19fa6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e19fa6e",
  null
  
)

export default component.exports